export const OPTIMIZATION_TITLES = {
  POLICYHOLDER_EMAIL: "Policyholder Email",
  MYSAGESURE_ACCOUNT: "MySageSure Account",
  PAPERLESS: "Paperless Enrollment",
  BILLING: "Payment Plan"
};
